import { coerceBoolean } from "./coerceBoolean";

export const getQueryStringValue = (key: string): string | undefined => {
  const result = new URLSearchParams(window.location.search).get(key);
  return result === null ? undefined : result;
};

export const getIsQueryStringPresent = (key: string): boolean => {
  return getQueryStringValue(key) !== undefined;
};

export const getQueryStringValueTyped = <T>(
  key: string,
  coerceFunction: (value: string) => T,
): T | undefined => {
  const value = getQueryStringValue(key);
  return value === undefined ? undefined : coerceFunction(value);
};

/**
 * Check is query string is truthy, `includePresence` will be truthy if the query string key exists
 * and otherwise only if a truthy value such as `true`, 1, `TRUE`, `tRuE`, etc.
 */
export const getIsQueryStringTruthy = (
  key: string,
  includePresence: boolean = false,
): boolean => {
  let value = getQueryStringValue(key);
  if (includePresence && value !== undefined) {
    return true;
  }

  return coerceBoolean(value);
};

export const getQueryStringValues = (key: string): string[] => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.getAll(key + "[]").concat(urlParams.getAll(key));
};

export const getQueryStringValuesTyped = <T>(
  key: string,
  coerceFunction: (value: string) => T,
): T[] | undefined => {
  const values = getQueryStringValues(key);
  if (values.length === 0) {
    return undefined;
  }

  return values.map(coerceFunction).filter((value) => value !== undefined);
};

export const getFragmentValue = (key: string): string | undefined => {
  const result = new URLSearchParams(window.location.hash.slice(1)).get(key);
  return result === null ? undefined : result;
};
